import React from 'react';
import IconPicker from './IconPicker';
import defaultApiFetch from '../../../utils/apiFetch';

/**
 * 队员/设备图标选择器（写入 devices.icon）
 * 兼容旧组件 IconSelector 的 props
 */
export default function DeviceIconSelector({
  value,
  onChange,
  placeholder = '选择图标',
  style = {},
  size = 'default',
  showPreview = true,
  deviceId = null,
  onIconChange = null,
  apiFetch = defaultApiFetch
}) {
  const persist = async (newIcon) => {
    onChange?.(newIcon);
    if (!deviceId) {
      onIconChange?.(newIcon);
      return;
    }
    try {
      const response = await apiFetch('/api/device/icon', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ device_unique_id: deviceId, icon: newIcon })
      });
      const data = await response.json().catch(() => ({}));
      if (data.success) onIconChange?.(newIcon);
      else console.error('设备图标更新失败:', data.error);
    } catch (e) {
      console.error('更新设备图标失败:', e);
    }
  };

  return (
    <IconPicker
      source="builtin"
      valueMode="key"
      value={value}
      onChange={persist}
      placeholder={placeholder}
      style={style}
      size={size}
      showPreview={showPreview}
    />
  );
}
